(function () {
  const formatCurrency = (amount) => {
    return '$' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '');
  };

  const initShippingCalculator = (calculator) => {
    const variantId = calculator.dataset.variantId;
    const provinceSelect = calculator.querySelector('.shipping-calculator__province');
    const postalInput = calculator.querySelector('.shipping-calculator__postal');
    const calculateButton = calculator.querySelector('.shipping-calculator__submit');
    const resultsContainer = calculator.querySelector('.shipping-results');
    const loadingElement = calculator.querySelector('.shipping-loading');
    const errorElement = calculator.querySelector('.shipping-error');

    if (!variantId || !provinceSelect || !postalInput || !calculateButton) {
      return;
    }

    const displayResults = (data) => {
      loadingElement.style.display = 'none';

      if (!data.shipping_rates || data.shipping_rates.length === 0) {
        errorElement.textContent = 'No hay opciones de envío disponibles para este destino.';
        errorElement.style.display = 'block';
        return;
      }

      let resultsHTML = '<h4>Opciones de envío disponibles:</h4>';

      data.shipping_rates.forEach((option) => {
        const price = parseFloat(option.price);
        let estimatedDelivery = '3-7 días hábiles';

        if (option.name.toLowerCase().includes('express')) {
          estimatedDelivery = '1-2 días hábiles';
        } else if (option.name.toLowerCase().includes('estándar')) {
          estimatedDelivery = '3-5 días hábiles';
        }

        if (option.name.includes('ShipNow') && option.name.includes('(')) {
          const deliveryInfo = option.name.match(/\((.*?)\)/);
          if (deliveryInfo && deliveryInfo[1]) {
            estimatedDelivery = deliveryInfo[1];
          }
        }

        resultsHTML += `
          <div class="shipping-option">
            <div class="option-info">
              <strong>${option.name}</strong>
              <div>Tiempo estimado: ${estimatedDelivery}</div>
            </div>
            <div class="option-price">
              <strong>${formatCurrency(price)}</strong>
            </div>
          </div>
        `;
      });

      resultsContainer.innerHTML = resultsHTML;
      resultsContainer.style.display = 'block';
    };

    const calculateShipping = async () => {
      const province = provinceSelect.value;
      const postalCode = postalInput.value.trim();

      if (!province || !postalCode) {
        errorElement.textContent = 'Por favor, completá todos los campos.';
        errorElement.style.display = 'block';
        resultsContainer.style.display = 'none';
        return;
      }

      loadingElement.style.display = 'block';
      errorElement.style.display = 'none';
      resultsContainer.style.display = 'none';

      try {
        const url =
          '/cart/shipping_rates.json?shipping_address[zip]=' +
          encodeURIComponent(postalCode) +
          '&shipping_address[province]=' +
          encodeURIComponent(province) +
          '&shipping_address[country]=Argentina';

        const cartResponse = await fetch('/cart/clear.js', { method: 'POST' });

        if (!cartResponse.ok) {
          throw new Error('No se pudo limpiar el carrito');
        }

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!addResponse.ok) {
          throw new Error('No se pudo agregar el producto al carrito');
        }

        const shippingResponse = await fetch(url);

        if (!shippingResponse.ok) {
          throw new Error('Error al consultar las opciones de envío');
        }

        const shippingData = await shippingResponse.json();
        displayResults(shippingData);

        await fetch('/cart/clear.js', { method: 'POST' });
      } catch (error) {
        console.error('Error calculando envío:', error);
        loadingElement.style.display = 'none';
        errorElement.textContent =
          'No se pudieron calcular las opciones de envío. Por favor, verificá el código postal e intentá nuevamente.';
        errorElement.style.display = 'block';
        fetch('/cart/clear.js', { method: 'POST' });
      }
    };

    calculateButton.addEventListener('click', calculateShipping);

    postalInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        calculateShipping();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shipping-calculator').forEach(initShippingCalculator);
  });
})();
